// extracted by mini-css-extract-plugin
export default {"Container":"swiper-slide_Container__9UNfw","Content":"swiper-slide_Content__K-lmq"};